import { atom } from 'recoil';
import { Device } from '../types/device';
import { DeviceCarrier } from '../types/deviceCarrier';

export const selectDeviceState = atom<Device | undefined>({
  key: 'app.crm.device.select',
  default: undefined,
});

export const deviceCarriersState = atom<DeviceCarrier[] | undefined>({
  key: 'app.crm.device.carrier',
  default: undefined,
});

export const deviceModelBrandSelectState = atom<string | undefined>({
  key: 'app.crm.devices.model.brand.select',
  default: undefined,
});
